import index from './index.vue';
import { MessageForm } from './all.type';

export default index;
export {
    MessageForm
};